import type { ResponseMessages } from '../types';

const messages: ResponseMessages = {
  'response.responseDefinitionWasDeleted': '此响应已被删除，请重新选择',
  'response.responseIsNotJson': '返回的数据格式不是 JSON',
  'response.responseIsNotMsgpack': '返回的数据格式不是 Msgpack',
  'response.responseIsNotNoContent': '该响应不应该有 Body',
  'response.resultResponseWithDetail': '应当是 {responseDefinition} 实际却是 {response}',
  'response.responseSizeThreshold': '返回响应超过 50MB 不显示',
  'response.imageContentType': '图片：{type}',
  'response.fileContentType': '文件：{type}',
  'response.pdfContentType': 'PDF：{type}',
  'response.videoContentType': '视频：{type}',
  'response.tooManyCharacters': '出于性能原因，未对响应内容格式化。',
  'response.saveAsFile': '将返回值保存为文件',
} as const;

export default messages;
